const MenuRightIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		{...props}
	>
		<rect x="2" y="2" width="10" height="10" stroke="currentColor" fill="none" strokeWidth="2" />
		<rect x="8" y="4" width="2" height="6" fill="currentColor" />
	</svg>
)

export default MenuRightIcon